import {type, define, Record, attr} from "type-r";
import ProfileModel from "./ProfileModel";

@define
class UserModel extends Record {
    @attr username: string;
    @type(Date).has.toJSON(false).as date_joined: Date;
    @type(Date).has.toJSON(false).as last_login: Date;
    @attr password: string;
    @attr(ProfileModel) userprofile: ProfileModel;

    get number_for_sort(){
        return this.userprofile.ownerships.first()?.address || this.username;
    }
    static comparator = 'number_for_sort'
}

export default UserModel;


// WEBPACK FOOTER //
// ./src/models/UserModel.ts